import React from 'react';
import { useNavigate } from 'react-router-dom';
import AvatarFrame from '../AvatarFrame/AvatarFrame';
import { getProfilePhotoSrc, PLACEHOLDER_DATA_URI } from '../../../utils/profilePhoto';
import Icon from '../Icon/Icon';
import '../../pages/Search/OneSearch.css';

/**
 * One binder fit, shown as the trade itself: the cards you'd GET and
 * GIVE as thumbnails with rough values, plus View binder / Send trade.
 * Used by the Traders page and the Trade page's "who is it for?"
 * picker. `m` is a row from /api/suggested/users.
 */
const dedupe = (cards) => [...new Map((cards || []).map(c => [c.uuid, c])).values()];

function Strip({ label, kind, cards, value }) {
    const list = dedupe(cards);
    if (!list.length) return null;
    return (
        <div className={`os-match-strip ${kind}`}>
            <div className="os-match-striphead">
                <span className="os-match-label">{label}</span>
                {value > 0 && <span className="os-match-value">~${value.toFixed(2)}</span>}
            </div>
            <div className="os-match-cards">
                {list.slice(0, 6).map((c, i) => (
                    c.image_path
                        ? <img key={`${c.uuid}-${i}`} src={c.image_path} alt={c.name} title={c.name} loading="lazy" />
                        : <span key={`${c.uuid}-${i}`} className="os-match-noimg" title={c.name}>{c.name}</span>
                ))}
                {list.length > 6 && <span className="os-match-more">+{list.length - 6} more</span>}
            </div>
        </div>
    );
}

function TraderMatch({ m }) {
    const navigate = useNavigate();
    return (
        <div className="os-match">
            <div className="os-match-head">
                <AvatarFrame user={m}>
                    <img
                        src={getProfilePhotoSrc(m)}
                        alt={m.username}
                        onError={e => { e.target.onerror = null; e.target.src = PLACEHOLDER_DATA_URI; }}
                    />
                </AvatarFrame>
                <div className="os-match-who">
                    <span className="os-user-name">
                        {m.username}
                        {m.mutualMatch && <span className="os-mutual">two-way fit</span>}
                    </span>
                    {m.location && (
                        <span className="os-user-meta">
                            <Icon name="pin" /> {m.location}{m.distance != null ? ` · ${m.distance} mi` : ''}
                        </span>
                    )}
                </div>
            </div>
            <Strip label="You'd get" kind="get" cards={m.cardsTheyHave} value={m.valueTheyHave} />
            <Strip label="You'd give" kind="give" cards={m.cardsTheyWant} value={m.valueTheyWant} />
            <div className="os-match-actions">
                <button className="os-btn ghost" onClick={() => navigate(`/profile/${m.id}`)}>View binder</button>
                <button className="os-btn gold" onClick={() => navigate('/trade', { state: { ownerId: Number(m.id) } })}>Send trade</button>
            </div>
        </div>
    );
}

export default TraderMatch;
